import { FABRIC_BG } from "../../util/tableRip";

export const DateTo = (toDate) => {
  return (
    <div className="w-[11.36%] h-[100%] content-center font-rubik text-xl font-light">
      {toDate}
    </div>
  );
};

export const DateFrom = (fromDate, color) => {
  return (
    <div className={`w-[11.36%] ${FABRIC_BG[
          Object.keys(FABRIC_BG).find((key) => color.toUpperCase().includes(key))
        ] || ''} rounded-l-[8px]`}>
      <div
        className={`h-[100%] content-center font-rubik font-light text-xl  rounded-l-[8px]`}>
        {fromDate}
      </div>
    </div>
  );
};

export const MembersBlock = (manager, designer, sewing) => {
  return (
    <div className="flex w-[16.41%] bg-[#F9F9F9] justify-center">
      <div className="flex flex-1 items-center px-[24px] ">
        <div className="place-items-start">{renderImage(manager|| "none")}</div>
        <div className="place-items-center">{renderImage(designer|| "none")}</div>
      </div>
    </div>
  );
};
export const renderImage = (nameIMG) => {
  if (!nameIMG) return null;

  try {
    const safeName = encodeURIComponent(nameIMG.trim());
    const image = `${process.env.PUBLIC_URL}/assets/${safeName}.png`;

    return (
      <div>
        <img
          src={image}
          style={{
            height: "48px",
            width: "70px",
            margin: "auto",
            objectFit: "contain",
          }}
          title={nameIMG}
          alt={nameIMG}
        />
      </div>
    );
  } catch {
    return null;
  }
};